// start:ng42.barrel
import './balance-summary-widget.component';
import './current-user-transaction-view-uib-container.component';
import './current-user-transaction-view.component';
// end:ng42.barrel

